var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from './model';
import DtoConverter from '../core/utils/dto-converter';
import { User } from './user';
import { CartItem } from './cart-item';
import { Currency } from './currency';
import { Country } from './country';
import { Invoice } from './invoice';
var Order = /** @class */ (function (_super) {
    __extends(Order, _super);
    function Order(data) {
        var _this = _super.call(this, data) || this;
        if (data.user) {
            _this.user = new User(data.user);
        }
        if (data.currency) {
            _this.currency = new Currency(data.currency);
        }
        if (data.shipping_country) {
            _this.shipping_country = new Country(data.shipping_country);
        }
        if (data.billing_country) {
            _this.billing_country = new Country(data.billing_country);
        }
        if (data.cart_items) {
            _this.cart_items = DtoConverter.createList(CartItem, data.cart_items);
        }
        if (data.invoices) {
            _this.invoices = DtoConverter.createList(Invoice, data.invoices);
        }
        return _this;
    }
    Order.prototype.getTotal = function () {
        var total = 0;
        this.cart_items.forEach(function (item) { return total += item.getTotal(); });
        if (this.shipping_fee) {
            total += this.shipping_fee;
        }
        if (this.coupon_discount_amount) {
            total -= this.coupon_discount_amount;
        }
        return total;
    };
    Order.prototype.getAddress = function () {
        var _a, _b;
        if ('en' === window.App.locale.locale) {
            return "" + this.shipping_address + (this.shipping_address2 ? " " + this.shipping_address2 : '') + ", " + this.shipping_zip_code + " " + this.shipping_city + ", " + ((_a = this.shipping_country) === null || _a === void 0 ? void 0 : _a.name);
        }
        return "" + this.shipping_address + (this.shipping_address2 ? " " + this.shipping_address2 : '') + ", " + this.shipping_zip_code + " " + this.shipping_city + ", " + ((_b = this.shipping_country) === null || _b === void 0 ? void 0 : _b.name);
    };
    return Order;
}(Model));
export { Order };
